import { createChatAutoAssignSettings } from './chat';
export * from './chat';
export var createAutoAssignApi = function (baseUrl, http) {
    var autoAssignApiUrl = "".concat(baseUrl, "/auto-assign");
    return {
        chat: createChatAutoAssignSettings(autoAssignApiUrl, http)
    };
};
//# sourceMappingURL=index.js.map